import { Box, useMediaQuery } from '@mui/material';
import SlideIn from '../../../SlideIn';

const News = () => {
    const isSmallScreen = useMediaQuery("(max-width:414px)");
    const mainFontSize = isSmallScreen ? '60px' : '120px';
    return (
        <Box
            sx={{
                position: 'relative',
            }}>

            {/* MainText */}
            <Box sx={{
                fontSize: mainFontSize,
                fontFamily: 'Koulen',
                lineHeight: 0.8,
            }}>
                <SlideIn text='NEWS' />
            </Box>

            {/* subText */}
            <Box sx={{
                fontSize: '30px',
                marginBottom: '10%',
                fontFamily: 'Zen Old Mincho',
            }}>
                <SlideIn text='最新のニュース' />
            </Box>
        </Box>
    );
};

export default News;